"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WorkerMessages;
(function (WorkerMessages) {
    WorkerMessages["PROGRESS"] = "progress";
    WorkerMessages["SUCCESS"] = "success";
    WorkerMessages["START"] = "start";
    WorkerMessages["UPLOAD"] = "upload";
    WorkerMessages["CANCEL"] = "cancel";
    WorkerMessages["ERROR"] = "error";
    WorkerMessages["CONFIG"] = "config";
})(WorkerMessages = exports.WorkerMessages || (exports.WorkerMessages = {}));
